<template>
  <div>

    <div class="trades-head">
      <span @click="routeUser()" class="hover">
        <Avatar  v-if="record.avatar != null" class="trades-avatar" :src="`https://tradeinpool.com/upload/${record.avatar}.png`" :size="40"></Avatar>
        <Avatar  v-else class="trades-avatar" :username="record.username" :size="40"></Avatar>
        </span>
      <span class="trades-pl">
        <span
          class="pl-center"
          v-bind:class="record.stats.result > 0 ? 'up' : 'down'"
        >$ {{record.stats.result.toFixed(2)}}</span>
      </span>
      <b @click="routeUser()">{{record.username}}</b>
      
    </div>
    <div class="trades-content">
        {{record.stats.trades}} Trades
    </div>
  </div>
</template>

<script>
import Avatar from "vue-avatar";

export default {
  components:{
    Avatar
  },
  props: ["record"],
  data(){
    return{
    }
  },
  methods: {
    routeUser() {

      return this.$router.push({path: "/user/"+this.record.username});
    }
  },
  computed: {
    
  },
  filters: {
    
    sizator: function(value) {
      if (value > 1) return value + " pcs";
      else return value + " pc";
    }
  }
};
</script>

<style scoped>

.list-enter-active,
.list-leave-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
}

.loss {
  color: #e62163;
}

.profit {
  color: #79c04d;
}


.trades-head {
  width: 100%;
  position: relative;
  padding-right: 10px;
  padding-left: 55px;
  padding-top: 3px;
  height: 19px;
  float: left;
  color: #ffffff;
}

.trades-pl {
  float: right;
  font-size: 14px;
  font-family: "Roboto Condensed", sans-serif;
  font-weight: bold;
}

.pl-center {
  position: relative;
  top: 7px;
}

.trades-content {
  width: 100%;
  float: left;
  margin-left: 55px;
  color: #808f9c;
}


</style>
